import React, { Component } from 'react';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/* add css styles here (optional) */\n\n.styles_LavaLampMenu__14r8q {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tposition: relative;\n}\n\n.styles_item__16yus {\n\tuser-select: none;\n\ttransition: color 0.2s, background 0.2s;\n}\n.styles_name__13yyl {\n\tposition: relative;\n}\n\n.styles_selected__2tcap {\n\ttransition-delay: 0.1s;\n}\n\n.styles_slider__XPlXY {\n\tposition: absolute;\n\ttop: 0px;\n\tleft: 0px;\n\ttransition: margin 0.2s, width 0.2s;\n}";
var styles = { "LavaLampMenu": "styles_LavaLampMenu__14r8q", "item": "styles_item__16yus", "name": "styles_name__13yyl", "selected": "styles_selected__2tcap", "slider": "styles_slider__XPlXY" };
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var LavaLampMenu = function (_Component) {
  inherits(LavaLampMenu, _Component);

  function LavaLampMenu() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LavaLampMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LavaLampMenu.__proto__ || Object.getPrototypeOf(LavaLampMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sliderPosition: {},
      mouseOverItemId: ""
    }, _this.handleItemMouseOver = function (id) {
      _this.setState({
        mouseOverItemId: id
      });
    }, _this.handleMouseLeave = function () {
      _this.setState({
        mouseOverItemId: ""
      });
    }, _this.handleItemClick = function (id) {
      _this.props.onSelectedItemChange(id);
    }, _this.getSliderPosition = function () {
      var _this$props = _this.props,
          selectedItemId = _this$props.selectedItemId,
          items = _this$props.items;
      var sliderPosition = _this.state.sliderPosition;

      var index = items.findIndex(function (_ref2) {
        var id = _ref2.id;
        return id === selectedItemId;
      });
      var selectedItemDiv = _this[_this.getItemId(selectedItemId)];

      var _selectedItemDiv$getB = selectedItemDiv.getBoundingClientRect(),
          x = _selectedItemDiv$getB.x,
          y = _selectedItemDiv$getB.y,
          width = _selectedItemDiv$getB.width,
          height = _selectedItemDiv$getB.height;

      var _this$menuContainer$g = _this.menuContainer.getBoundingClientRect(),
          menuContainerX = _this$menuContainer$g.x;

      var sliderMarginLeft = x - menuContainerX;
      var sliderWidth = width; //+ itemPadding*2

      if (sliderMarginLeft !== sliderPosition.marginLeft || sliderWidth !== sliderPosition.width) {
        _this.setState({
          sliderPosition: {
            marginLeft: sliderMarginLeft,
            width: sliderWidth
          }
        });
      }
    }, _this.getItemId = function (id) {
      return 'item-' + id;
    }, _this.getItemStyle = function (id) {
      var _this$props2 = _this.props,
          itemStyle = _this$props2.itemStyle,
          mouseOverItemStyle = _this$props2.mouseOverItemStyle,
          selectedItemStyle = _this$props2.selectedItemStyle,
          selectedItemId = _this$props2.selectedItemId;
      var mouseOverItemId = _this.state.mouseOverItemId;

      var toReturn = _extends({}, itemStyle);
      if (id === mouseOverItemId) {
        toReturn = _extends({}, toReturn, mouseOverItemStyle);
      }
      if (id === selectedItemId) {
        toReturn = _extends({}, toReturn, selectedItemStyle);
      }
      return toReturn;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(LavaLampMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getSliderPosition();
      window.addEventListener("resize", this.getSliderPosition);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.getSliderPosition();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.getSliderPosition);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          selectedItemId = _props.selectedItemId,
          itemStyle = _props.itemStyle,
          sliderStyle = _props.sliderStyle,
          mouseOverItemBackgroundColor = _props.mouseOverItemBackgroundColor;
      var _state = this.state,
          sliderPosition = _state.sliderPosition,
          mouseOverItemId = _state.mouseOverItemId;


      return React.createElement(
        'div',
        { className: styles.LavaLampMenu, ref: function ref(r) {
            return _this2.menuContainer = r;
          } },
        React.createElement('div', { className: styles.slider, style: _extends({}, sliderStyle, sliderPosition) }),
        items.map(function (_ref3) {
          var id = _ref3.id,
              name = _ref3.name;

          var isSelected = id === selectedItemId;
          return React.createElement(
            'div',
            {
              ref: function ref(itemDiv) {
                return _this2[_this2.getItemId(id)] = itemDiv;
              },
              onClick: function onClick() {
                return _this2.handleItemClick(id);
              },
              onMouseOver: function onMouseOver() {
                return _this2.handleItemMouseOver(id);
              },
              onMouseLeave: function onMouseLeave() {
                return _this2.handleMouseLeave(id);
              },
              key: id,
              style: _this2.getItemStyle(id),
              className: styles.item + ' ' + (isSelected ? styles.selected : '') },
            React.createElement(
              'div',
              { className: styles.name },
              name
            )
          );
        })
      );
    }
  }]);
  return LavaLampMenu;
}(Component);

LavaLampMenu.propTypes = {
  items: PropTypes.array.isRequired,
  selectedItemId: PropTypes.string,
  itemStyle: PropTypes.object,
  mouseOverItemStyle: PropTypes.object,
  selectedItemStyle: PropTypes.object,
  onSelectedItemChange: PropTypes.func.isRequired,
  mouseOverItemBackgroundColor: PropTypes.string
};


LavaLampMenu.defaultProps = {
  sliderStyle: {},
  itemStyle: {},
  mouseOverItemStyle: {},
  selectedItemStyle: {}
};

export default LavaLampMenu;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 36
// module chunks = 0